Immutable = require 'seamless-immutable'

module.exports = {
	doing: (inProgressState, state) ->
		state.set inProgressState, true

	did: (inProgressState, state, action) ->
		state = state.set inProgressState, false
		state = state.set 'list', Immutable(action.payload.list) unless action.payload.error
		state
}



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/common.coffee